import { render, staticRenderFns } from "./video-stream.vue?vue&type=template&id=5b5adeb1&scoped=true&"
import script from "./video-stream.vue?vue&type=script&lang=ts&"
export * from "./video-stream.vue?vue&type=script&lang=ts&"
import style0 from "./video-stream.vue?vue&type=style&index=0&id=5b5adeb1&prod&scoped=true&lang=scss&"
import style1 from "./video-stream.vue?vue&type=style&index=1&id=5b5adeb1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5adeb1",
  null
  
)

export default component.exports